enum RolesEnum {
  ADMINISTRATOR = "ROLE_ADMINISTRATOR",
  SUPER_USER = "ROLE_SUPER_USER",
  CASH_ALL_READ = "ROLE_CASH_ALL_READ",
  CASH_ALL_WRITE = "ROLE_CASH_ALL_WRITE",
  RR_HH = "ROLE_RR_HH",
  MOBILE = "ROLE_MOBILE",
  EXPENSE = "ROLE_EXPENSE",
  PRICE_WHOLESALE = "ROLE_PRICE_WHOLESALE",
  SALE_CREDIT = "ROLE_SALE_CREDIT",
}

export default RolesEnum;